<div class="cta-container" *ngIf="!(typingMode || isRecording)" [@fadeOut]="startAnimation && activeScreen !== 'TEXT' ? 'void' : '*'">
	<div class="channel-image-container" fxLayout="row">
		<div class="channel-image-border">
			<img [alt]="channel?.name" [src]="channel?.image?.url || './assets/images/default.png'" class="channel-image" (click)="close.emit($event)" />
		</div>
	</div>
	<div fxLayout="row" class="cta-text" [style.width]="ctaWidth" [ngStyle]="getBackgroundColor()">
		<h3 class="cta text-center w-full" *ngIf="!finishedResponding">{{ ctaText ? ctaText : notification?.cta }}</h3>
		<h3 class="cta text-center w-full" *ngIf="finishedResponding">Jott received. Thank you!</h3>
	</div>
</div>
